module.exports = __webpack_public_path__ + "img/rsz_digital-marketing-new-startup-project-online-search-engine-optimisation.579579ee.png";